import * as React from 'react';
import {
    ModalBody,
    ModalFooter,
    Button, ModalHeader, Modal, ModalTitle
} from 'react-bootstrap';
import {CommonAssociationFeature} from "../../contract-features-3/domain";
import {AttributeType} from "../../../../integration/datacatalog/datacatalog-services";

interface AssociateAndConnectButtonProps {
    associate: Function;
    anyTargetsSelected: boolean;
    featureIsExporting: boolean;
    selectedTargetFeatures: CommonAssociationFeature[];
}

interface AssociateAndConnectButtonState {
    showModal: boolean;
}


export default class AssociateAndConnectParentButton extends React.Component<AssociateAndConnectButtonProps, AssociateAndConnectButtonState> {

    constructor(props: AssociateAndConnectButtonProps) {
        super(props);
        this.state = {
            showModal: false
        };
    }

    closeConfirmModal() {
        this.setState({
            showModal: false
        });
    }

    openConfirmModal() {
        this.setState({showModal: true});
    }

    getMissingAttributeTypes(): AttributeType[] {
        const missingAttributeTypes: AttributeType[] = [];
        (this.props.selectedTargetFeatures ?? []).forEach(
            feature => (feature.missingAttributeTypes ?? []).forEach(
                attributeType => missingAttributeTypes.push(attributeType)
            )
        )
        const uniqueIds = [...new Set(missingAttributeTypes.map(attributeType => attributeType.id))];

        const uniqueMissingAttributeTypes: AttributeType[] = []

        uniqueIds.forEach(id => uniqueMissingAttributeTypes.push(missingAttributeTypes.find(attributeType => attributeType.id === id)))

        return uniqueMissingAttributeTypes;
    }

    handleAssociateClick() {

        const missingAttributeTypes: AttributeType[] = this.getMissingAttributeTypes();

        const someSensitivityIsMissing: boolean = missingAttributeTypes.length > 0;

        if (someSensitivityIsMissing) {
            // Åpne modal hvis brukeren ikke har rettigheter
            this.openConfirmModal();
        } else {
            // Ellers koble og importer
            this.props.associate();
        }

    }

    confirm() {
        this.closeConfirmModal();
        this.props.associate();
    }

    render() {
        let title = "Rettigheter mangler";
        let {showModal} = this.state;
        let {anyTargetsSelected, featureIsExporting} = this.props;
        const missingAttributeTypes: AttributeType[] = this.getMissingAttributeTypes();
        const numberOfObjects = this.props.selectedTargetFeatures.length;

        let footer =
            <ModalFooter>
                <Button bsStyle="default" onClick={(e) => this.closeConfirmModal()}>Lukk</Button>
                <Button bsStyle="default" onClick={(e) => this.confirm()}>Koble og importer mor</Button>
            </ModalFooter>;

        let body = (
            <ModalBody className="autoassociate-modal">
                {numberOfObjects > 1 ? "Noen av objektene" : "Objektet"} inneholder sensitive egenkaper du ikke har rettigheter til å importere:
                <ul style={{"margin": "10px 0"}}>
                    {missingAttributeTypes.map(attributeType => {
                        return (
                            <li>{attributeType.name}</li>
                        )
                    })}
                </ul>

                Du kan importere {numberOfObjects > 1 ? "vegobjektene" : "vegobjektet"}, men disse egenskapene vil bli
                utelatt. Dersom du sender inn endringer på {numberOfObjects > 1 ? "objektene" : "objektet"} vil
                allikevel de sensitive dataene ivaretas.
            </ModalBody>
        );


        return (
            <div>
                <Button
                    className="associate-button"
                    onClick={() => this.handleAssociateClick()}
                    disabled={!anyTargetsSelected || featureIsExporting}
                >
                    Koble og importer mor
                </Button>
                {showModal &&
                    <Modal show={true} onHide={() => this.closeConfirmModal()}>
                        <ModalHeader>
                            <ModalTitle>{title}</ModalTitle>
                        </ModalHeader>
                        {body}
                        {footer}
                    </Modal>
                }
            </div>
        )
    }
}
